module.exports = __webpack_public_path__ + "img/img-6.db9f5cd2.webp";